import { fetchAuthSessionWithLoginMismatchRetry } from "../../utils/amplifyAuthRecovery";
import { isEnglish, t } from "@/localization";
import { evtLiveOwnerHeaders } from "../teams/workspace";
import { supportApi } from "./config";
export async function supportRequest(
  body,
  session,
  {
    history = false,
    previous = false,
    seen = false,
    anonymous = false,
    signal,
  } = {}
) {
  // Visitors who aren't signed in (website chat) send no account token.
  let token = null;
  if (!anonymous) {
    const auth = await fetchAuthSessionWithLoginMismatchRetry();
    token = auth.tokens?.accessToken?.toString();
    if (!token) throw new Error(t("Please sign in to contact support."));
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 150000);
  // previous=1 adds the account's earlier conversations (other devices, Intercom/Fin);
  // seen=1 tells the team the customer has the chat open, so read replies aren't emailed.
  const read = history || previous;
  const query = [
    history && session ? `id=${encodeURIComponent(session.id)}` : null,
    previous ? "previous=1" : null,
    history && seen ? "seen=1" : null,
  ]
    .filter(Boolean)
    .join("&");
  let response;
  try {
    response = await fetch(read ? `${supportApi}?${query}` : supportApi, {
      method: read ? "GET" : "POST",
      signal: signal || controller.signal,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { "X-Eventlive-Token": token } : {}),
        ...(session ? { Authorization: `Bearer ${session.token}` } : {}),
        // In someone else's account (Teams) a message is about that account,
        // so support answers about its events. History stays your own.
        ...(token && !read ? evtLiveOwnerHeaders(body?.eventSlug) : {}),
      },
      ...(!read ? { body: JSON.stringify(body) } : {}),
    });
  } catch (error) {
    // fetch's own messages ("Network request failed") are in English: English
    // keeps them, other languages get their own.
    if (isEnglish()) throw error;
    throw new Error(
      t(
        "Could not reach support. Check your internet connection and try again."
      )
    );
  } finally {
    clearTimeout(timer);
  }
  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error(t("Support is temporarily unavailable. Please try again."));
  }
  if (!response.ok) {
    const error = new Error(data.error || t("Could not send your message."));
    error.status = response.status;
    throw error;
  }
  return data;
}
